import { FormProvider, UseFormReturn } from 'react-hook-form'
import { connect, DataItem } from 'scrivito'

import { DataItemFormBody } from './DataItemForm.Body'
import { Form, FormHeader } from '@/Atomic/Templates/Form'
import { getDataItemTitle } from '@/utils/dataClassMap'

import './DataItemForm.scss'

interface DataItemFormProps {
  dataItem: DataItem
  methods: UseFormReturn
  onFormSubmit?: () => void
  isEditing: boolean
}

export const DataItemForm: React.FC<DataItemFormProps> = connect(
  ({ dataItem, isEditing, methods, onFormSubmit }) => {
    const title = getDataItemTitle(dataItem)

    return (
      <FormProvider {...methods}>
        <Form onSubmit={onFormSubmit}>
          <FormHeader>{title}</FormHeader>
          <DataItemFormBody dataItem={dataItem} isEditing={isEditing} />
        </Form>
      </FormProvider>
    )
  },
)
